import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {GradesActions} from '../store';
import {GradesSelectors} from '../store/selectors';

@Injectable()
export class GradesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadGradesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadGradesDone() {

    return this.store.pipe(
      select(GradesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(GradesActions.ReadGrades());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
